import createIcon from '../../createIcon';

/**
 * @component @name ExpandLess
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgOC4yOTQ5Mkw2IDE0LjI5NDlMNy40MSAxNS43MDQ5TDEyIDExLjEyNDlMMTYuNTkgMTUuNzA0OUwxOCAxNC4yOTQ5TDEyIDguMjk0OTJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ExpandLess = createIcon('ExpandLess', [
  [
    'path',
    {
      d: 'M12 8.29492L6 14.2949L7.41 15.7049L12 11.1249L16.59 15.7049L18 14.2949L12 8.29492Z',
      key: '1r3bdh',
    },
  ],
]);

export default ExpandLess;
